import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22.167 10.5H10.5a2.333 2.333 0 00-2.333 2.333v7a2.333 2.333 0 002.333 2.334h11.667a2.333 2.333 0 002.333-2.334v-7a2.333 2.333 0 00-2.333-2.333z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.833 10.5V8.167A2.333 2.333 0 0017.5 5.833H5.833A2.333 2.333 0 003.5 8.167v7A2.333 2.333 0 005.833 17.5h2.334"
      ></path>
    </svg>
  )
}

export default Icon
